import { store } from '@/state/store';
import { DTO__ml_asset } from '@shared/dto/+model/sd/ml_asset/DTO__ml_asset';
import { FN_FIELD_CONTAINER__init_values_allowed_only } from '@shared/dto/generation/graph_invoke/_fields/_base/_methods/FN_FIELD_CONTAINER__init_values_allowed_only';
import { DTO_GRAPH__instance } from '@shared/dto/generation/graph_invoke/_graph/DTO_GRAPH__instance';

export function INIT_EXTENSION__graph_instance_client() {
  DTO_GRAPH__instance.prototype.values_allowed__fill = values_allowed__fill;
}

function values_allowed__fill(this: DTO_GRAPH__instance) {
  /*
   * PRIMITIVE FIELDS
   */

  for (const node of this.nodes_map.values()) {
    FN_FIELD_CONTAINER__init_values_allowed_only(node);
  }

  /*
   * ML ASSET
   */

  const ml_assets = Array.from(store.getState().slice_ml_asset.ml_assets_map.values());
  ml_assets.sort(DTO__ml_asset.sort_by_name_and_version);

  this.values_ml_assets__fill(ml_assets);
  this.values_ml_assets__fill_lora(ml_assets);
  this.values_ml_assets__fill_control_net(ml_assets);
  this.values_ml_assets__fill_t2i_adapter(ml_assets);
}
